import { Alert, AlertTitle, Box } from '@mui/material';
import { useLocalization } from '../../providers/LocalizationProvider';

// Used on Login page or anywhere where formstate is not present
function FormErrorsArray({
  errors = [],
  withTitle = true,
  displayAsList = true,
}) {
  const { formatMessage } = useLocalization();

  let currentErrors = [];

  try {
    if (Array.isArray(errors)) {
      if (errors.length === 0) {
        currentErrors = [];
      } else if (typeof errors[0] === 'string') {
        currentErrors = errors.map(err => {
          return { path: '', message: err };
        });
      } else {
        currentErrors = errors;
      }
    } else if (typeof errors === 'object') {
      currentErrors = [errors];
    } else {
      currentErrors = [{ message: JSON.stringify(errors) }];
    }
  } catch (err) {
    currentErrors = [{ message: err.message }];
  }

  if (currentErrors && currentErrors?.length > 0) {
    const icon = !withTitle ? { icon: false } : {};
    return (
      <Alert {...icon} sx={{ mb: 2, mt: -1 }} severity="error">
        {withTitle && (
          <AlertTitle>
            {formatMessage({
              id: 'FORM_ERRORS',
              defaultMessage: `Errors (${currentErrors.length} issue${currentErrors.length > 1 ? 's' : ''} ${currentErrors.length > 1 ? 'have' : 'has'} to be fixed)`,
            })}
          </AlertTitle>
        )}
        {displayAsList ? (
          <ul style={{ margin: '0 0 0 0', padding: '0 0 0 17px' }}>
            {currentErrors.map((error, index) => {
              return <li key={error?.message || index}>{error?.message}</li>;
            })}
          </ul>
        ) : (
          <Box>
            {currentErrors.map((error, index) => {
              return <div key={error?.message || index}>{error?.message}</div>;
            })}
          </Box>
        )}
      </Alert>
    );
  }
  return null;
}

export default FormErrorsArray;
